import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const StaffRoute = ({ children }) => {
  const { user, loading, isStaff, supplierInfo } = useAuth();

  // Wait for both auth loading AND supplierInfo (which includes is_staff) to resolve.
  // supplierInfo is fetched non-blocking after loading=false, so we must wait for it too.
  if (loading || (user && supplierInfo === null)) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '100vh' }}>
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  if (!user) return <Navigate to="/login" replace />;
  if (!isStaff) return <Navigate to="/" replace />;

  return children;
};

export default StaffRoute;
